import React, { useEffect, useState } from 'react'
import CaseValidation from '../Case Validation/CaseValidation'
import './AgentViewChallenge.css'
import useAPIEndpoints from '../../../../models/api/apiEndpoints'
import { CircularProgress, Divider } from '@mui/material'
import { useFetch } from '../../../../models/api/api'
import { useAuthStore } from '../../../../store/useStore'
import DpsButton from '../../base/button/DpsButton'
import AddNoteIcon from '../../../../assets/addnote.svg'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import PauseIcon from '@mui/icons-material/Pause'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import EmailIcon from '@mui/icons-material/Email'
import CachedIcon from '@mui/icons-material/Cached'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PopMenu from '../../base/dialogBox/PopMenu'
import { MWLDialog } from 'react-web-white-label'

const AgentViewChallenge = ({
  pcnNumber,
  token,
  sliderstate,
  handleViewCaseInfo,
  handleCheckNumberOfNotes,
  handleCheckNumberOfCorrespondance,
  addNotesDialogProps = {},
  CancelPcnDialogBox,
  cancelPcnDialogProps = {},
  HoldPcnDialogBox,
  holdPcnDialogProps = {},
  OffHoldPcnDialogBox,
  offHoldPcnDialogProps = {},
  AddNotesDialog,
  setCaseDetails,
  caseDetails,
  viewDetails,
  setViewDetails,
  pcnActions,
  setPcnActions,
  isPcnStatusChanged,
  isViewChallengeEditable,
  setCorrespondanceData,
  correspondanceData,
  isAiraEnabled,
  isViewCaseInfoEnabled,
}) => {
  // Get appConfig from React context

  const [isloading, setIsLoading] = useState(false)
  const [summaryFetched, setSummaryFetched] = useState(false)
  const [challengeData, setChallengeData] = useState([])
  const [challengerName, setChallengerName] = useState([])
  const { setAuth, bearer } = useAuthStore()
  const [summaryDetails, setSummaryDetails] = useState([])
  const { fetchData } = useFetch()
  const APIEndPoints = useAPIEndpoints()
  const [anchorEl, setAnchorEl] = useState({ notes: null, corres: null })
  const [openPop, setopenPop] = useState({ notes: false, corres: false })
  const menuItems = {
    notes: [
      {
        label: 'To This Case',
        onClick: () => {
          handleCheckNumberOfNotes('single note') // Example function call, replace with actual logic
        },
      },
      {
        label: 'To Multiple Cases',
        onClick: () => {
          handleCheckNumberOfNotes('multiple notes') // Example function call, replace with actual logic
        },
      },
    ],
    corres: [
      {
        label: 'To This Case',
        onClick: () => {
          handleCheckNumberOfCorrespondance('single correspondance') // Example function call, replace with actual logic
        },
      },
      {
        label: 'To Multiple Cases',
        onClick: () => {
          handleCheckNumberOfCorrespondance('multiple correspondance') // Example function call, replace with actual logic
        },
      },
    ],
  }
  const GetSummaryDetails = async () => {
    try {
      const response = await fetchData(
        APIEndPoints.GetSummaryDetails.method,
        `${APIEndPoints.GetSummaryDetails.url}?pcnNumber=${pcnNumber}`
      )
      const responseData = response?.data || []
      setSummaryDetails(responseData)
      setSummaryFetched(true)
    } catch (err) {
      console.log(err)
    }
  }
  const fetchChallengerDetails = async (caseId) => {
    try {
      const response = await fetchData(
        APIEndPoints.GetContactAddress.method,
        APIEndPoints.GetContactAddress.url.replace('caseId', caseId),

        {
          postData: {
            PageNumber: 1, // This is the payload
            pageSize: 50, // This is the payload
          },
        }
      )
      setChallengerName(response.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const fetchCorrespondance = async (caseId) => {
    try {
      const response = await fetchData(
        APIEndPoints.GetCorrespondance.method,
        APIEndPoints.GetCorrespondance.url.replace('caseId', caseId),
        {
          postData: {
            PageNumber: 1,
            pageSize: 50,
          },
        }
      )
      if (!response) return

      // Axios -> JSON is already in response.data
      const data = response?.data?.data || []
      // Filter BackOffice files
      const backOfficeFiles = data.filter(
        (item) =>
          item.attachmentSource === 'BackOffice' &&
          item.isSendCorrespondence === true
      )

      // Combine citizen files with summaryDetails
      const citizenFilesCombined = data
        .filter(
          (file) =>
            file.attachmentSource === summaryDetails?.challengeSourceType
        )
        .map((file) => {
          const summaryItem = summaryDetails?.evidenceDetail?.find(
            (item) => item.evidenceId === file.id
          )
          return {
            evidenceId: summaryItem?.evidenceId,
            attachmentURL: file.attachmentURL || summaryItem?.attachmentURL,
            fileName: file.fileName || summaryItem?.fileName,
            source: file.attachmentSource || summaryItem?.source,
            fileDescription: summaryItem?.fileDescription,
            summary: summaryItem?.fileDescription || 'No summary available',
          }
        })
        .filter((item) => item.evidenceId) // ← Only keep items with matched evidenceId

      // ceo evidence
      const ceoEvidence = data.filter(
        (file) =>
          file?.attachmentSource?.toLowerCase() ===
          summaryDetails?.caseSourceType?.toLowerCase()
      )
      // Update state
      setCorrespondanceData((prevData) =>
        prevData.map((item) => ({
          ...item,
          backOfficeFilesToShow: backOfficeFiles,
          citizenFilesToShow: citizenFilesCombined,
          ceoFilesToShow: ceoEvidence,
        }))
      )
    } catch (err) {
      console.log(err)
    }
  }

  const fetchCaseDetails = async (caseId) => {
    try {
      const response = await fetchData(
        APIEndPoints.GetCeoImages.method,
        `${APIEndPoints.GetCeoImages.url}${caseId}`
      )
      // Update state
      setCaseDetails(response?.data || [])
    } catch (err) {
      console.log(err)
    }
  }
  const fetchDetails = async () => {
    try {
      const response = await fetchData(
        APIEndPoints.GetPCNDetails.method,
        APIEndPoints.GetPCNDetails.url,
        {
          postData: {
            searchText: pcnNumber,
          },
        }
      )
      setChallengeData(response?.data)
      const caseId = response?.data?.caseDetails?.[0]?.id || '-'
      if (caseId && caseId !== '-') {
        await Promise.all([
          fetchChallengerDetails(caseId),
          fetchCorrespondance(caseId),
          fetchCaseDetails(caseId),
        ])
      } else {
        console.warn('No case ID found in response.')
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    if (token) {
      setAuth({ bearer: token, idToken: null }) // ✅ set token
    }
    const loadData = async () => {
      if (!sliderstate) return
      setIsLoading(true)
      try {
        GetSummaryDetails()
      } catch (err) {
        console.log(err)
      }
    }
    loadData()
  }, [pcnNumber, token, sliderstate])
  useEffect(() => {
    if (summaryFetched) {
      fetchDetails()
    }
  }, [summaryFetched, isPcnStatusChanged])

  return (
    <>
      {isloading ? (
        <CircularProgress className="loading-indicator" />
      ) : (
        <div>
          <div className="challenge-name">
            {challengerName.some((item) => item.isKeeperAddress === 'true') ? (
              challengerName.map((item, index) => {
                const names = `${item.title} ${item.firstName} ${item.surname}`
                return (
                  <div key={index}>
                    <span>Name: </span> {names || '-'}
                  </div>
                )
              })
            ) : (
              <>
                {challengerName.length > 0 ? (
                  <>
                    <span>Name: </span> {challengerName[0].title}{' '}
                    {challengerName[0].firstName} {challengerName[0].surname}
                  </>
                ) : (
                  '-'
                )}
              </>
            )}
            <Divider orientation="vertical" variant="fullWidth" flexItem />

            <div className="stage">
              <span>Stage:</span>{' '}
              {challengeData?.caseDetails?.[0]?.stage || '-'}
            </div>
            <Divider orientation="vertical" variant="fullWidth" flexItem />

            <div className="status">
              <span>Status:</span>{' '}
              {challengeData?.caseDetails?.[0]?.status || '-'}
            </div>
            <Divider orientation="vertical" variant="fullWidth" flexItem />

            <div className="pcn-num">
              {isViewChallengeEditable && isViewCaseInfoEnabled && (
                <DpsButton
                  label={'VIEW CASE INFO'}
                  buttonVariant="text"
                  onClick={() => handleViewCaseInfo(pcnNumber)}
                  buttonType="primary"
                  startAdronIcon={<OpenInNewIcon color="primary" />}
                />
              )}
            </div>
          </div>
          <div className="scrollable-content">
            {' '}
            <div className="case-validation-container">
              {' '}
              <CaseValidation
                token={token}
                pcnNumber={pcnNumber}
                summaryDetails={summaryDetails}
                ceoFilesToShow={correspondanceData[0]?.ceoFilesToShow || []}
                citizenFilesCombined={
                  correspondanceData[0]?.citizenFilesToShow || []
                }
                backOfficeData={
                  correspondanceData[0]?.backOfficeFilesToShow || []
                }
                viewDetails={viewDetails}
                setViewDetails={setViewDetails}
                isViewChallengeEditable={isViewChallengeEditable}
              />
            </div>
          </div>
          {isViewChallengeEditable && (
            <div className="action-button-section">
              <div className="cancel-box">
                <DpsButton
                  label={'ADD NOTES'}
                  startAdronIcon={<img src={AddNoteIcon} alt="add" />}
                  buttonVariant="outlined"
                  buttonType="primary"
                  onClick={(e) => {
                    setAnchorEl({ ...anchorEl, notes: e.currentTarget })
                    setopenPop({ ...openPop, notes: true })
                  }}
                />
              </div>
              <div className="add-box">
                <DpsButton
                  label={'CANCEL'}
                  buttonVariant="outlined"
                  buttonType="error"
                  startAdronIcon={<DeleteForeverIcon />}
                  onClick={() =>
                    setPcnActions((prev) => ({ ...prev, cancelPcn: true }))
                  }
                  disabled={caseDetails?.status?.toLowerCase() === 'cancelled'}
                />{' '}
                {caseDetails?.status?.toLowerCase() !== 'onhold' && (
                  <DpsButton
                    label={'HOLD'}
                    buttonVariant="outlined"
                    startAdronIcon={<PauseIcon />}
                    buttonType="primary"
                    onClick={() =>
                      setPcnActions((prev) => ({ ...prev, holdPcn: true }))
                    }
                    disabled={
                      caseDetails?.status?.toLowerCase() === 'cancelled' ||
                      caseDetails?.status?.toLowerCase() === 'paid'
                    }
                  />
                )}
                {caseDetails?.status?.toLowerCase() === 'onhold' && (
                  <>
                    {' '}
                    <DpsButton
                      label={'SWAP HOLD'}
                      buttonVariant="outlined"
                      buttonType="primary"
                      startAdronIcon={<CachedIcon />}
                      onClick={() =>
                        setPcnActions((prev) => ({ ...prev, swapPcn: true }))
                      }
                      disabled={
                        caseDetails?.status?.toLowerCase() === 'cancelled'
                      }
                    />
                    <DpsButton
                      label={'OFF HOLD'}
                      buttonVariant="contained"
                      buttonType="primary"
                      startAdronIcon={<PlayArrowIcon />}
                      onClick={() =>
                        setPcnActions((prev) => ({ ...prev, offHold: true }))
                      }
                      disabled={
                        caseDetails?.status?.toLowerCase() === 'cancelled' ||
                        caseDetails?.isOnHoldEnabled === false
                      }
                    />
                  </>
                )}{' '}
                {!isAiraEnabled && (
                  <DpsButton
                    label={'SEND CORRESPONDENCE'}
                    buttonVariant="contained"
                    buttonType="primary"
                    onClick={(e) => {
                      setAnchorEl({ ...anchorEl, corres: e.currentTarget })
                      setopenPop({ ...openPop, corres: true })
                    }}
                    startAdronIcon={<EmailIcon />}
                  />
                )}
                {isAiraEnabled && (
                  <DpsButton
                    label={'SEND CORRESPONDENCE'}
                    buttonVariant="contained"
                    buttonType="primary"
                    onClick={() => handleCheckNumberOfCorrespondance('')}
                    startAdronIcon={<EmailIcon />}
                  />
                )}
                <PopMenu
                  id="add-notes-menu"
                  anchorEl={anchorEl.notes}
                  open={openPop.notes}
                  onClose={() => {
                    setAnchorEl({ ...anchorEl, notes: null })
                    setopenPop({ ...openPop, notes: false })
                  }}
                  items={menuItems?.notes}
                />
                <PopMenu
                  id="add-notes-menu"
                  anchorEl={anchorEl.corres}
                  open={openPop.corres}
                  onClose={() => {
                    setAnchorEl({ ...anchorEl, corres: null })
                    setopenPop({ ...openPop, corres: false })
                  }}
                  items={menuItems?.corres}
                />
              </div>
            </div>
          )}
          {AddNotesDialog && <AddNotesDialog {...addNotesDialogProps} />}
          {CancelPcnDialogBox && (
            <CancelPcnDialogBox {...cancelPcnDialogProps} />
          )}
          {HoldPcnDialogBox && <HoldPcnDialogBox {...holdPcnDialogProps} />}
          {OffHoldPcnDialogBox && (
            <OffHoldPcnDialogBox {...offHoldPcnDialogProps} />
          )}
        </div>
      )}
    </>
  )
}

export default AgentViewChallenge
